import * as yup from 'yup'
import { TYPE_REQUIRED, TYPE_EMAIL_INVALID, TYPE_UNMATCHED_PASSWORD } from 'constants/errors'

export default yup.object().shape({
  email: yup.string().email(TYPE_EMAIL_INVALID).required(TYPE_REQUIRED),
  code: yup.string().required(TYPE_REQUIRED),
  password: yup.string().required(TYPE_REQUIRED),
  password_confirm: yup.string().required(TYPE_REQUIRED)
    .test('passwords-match', TYPE_UNMATCHED_PASSWORD, function arePasswordsMatch () {
      return this.parent.password === this.parent.password_confirm
    }),
})
